// NOTE: Import polyfills before everything else to ensure they are loaded before any other code runs.
import './polyfills/polyfills'

import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { createStore } from '@verzekeringapp-mono/shared/src/state/configure_store'
import { PersistGate } from 'redux-persist/integration/react'
import sessionStorage from 'redux-persist/lib/storage/session'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
const { persistor, store } = createStore(sessionStorage)

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <PersistGate
          loading={null}
          persistor={persistor}
        >
          <App />
        </PersistGate>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

// NOTE: - Use this to cleanup the redux store.
// persistor.pause()
// persistor.flush().then(() => persistor.purge())
